import { fcApis } from '@apis/fcApis';
import { bookingInquiryStrings } from '@data/bookingInquiry';
import { PatchContact } from '@models/Contact';
import { FormError } from '@utils/errors';

export const validateContactZipcode = async (contact: PatchContact) => {
  if (contact.contact_type != null && contact.zip_code != null) {
    const isZipcodeJP = contact.contact_type === 'consignee' || contact.contact_type === 'receiver';

    const zipcodeResponse = await (isZipcodeJP
      ? fcApis.get('/fc/pref-and-city-by-zipcode/', {
          query: { zipcode: contact.zip_code! },
        })
      : fcApis.get('/fc/prov-and-city-by-zipcode/', {
          query: { zipcode: contact.zip_code! },
        }));

    if (!zipcodeResponse[200]) {
      throw new FormError('validateContactZipcode', {
        zipcode: bookingInquiryStrings.invalidZipcode,
      });
    }
  }
};
